
const getActualDate = (type) => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const hour = String(today.getHours()).padStart(2, '0');
    const min = String(today.getMinutes()).padStart(2, '0');
    if(type === "start"){
        return `${year}-${month}-${day} 00:00`;
    } 
    else if(type === "end"){
        return `${year}-${month}-${day} 23:59`;
    } 


}
export default getActualDate